import {
  ApolloClient,
  NormalizedCacheObject,
  useApolloClient,
} from '@apollo/client';
import React, { useMemo } from 'react';

import { useApiClient } from '@eluve/api-client-provider';
import { FCC } from '@eluve/components';
import { useNamedLogger } from '@eluve/logger';
import {
  useAssignedTenantIdFromParams,
  useUserIdFromSession,
} from '@eluve/session-helpers';

import { TaskProcessorProvider } from './TaskProcessorProvider';
import { createTaskHandlers } from './handlers';
import {
  getPersistedTasks,
  persistAppointmentTasks,
} from './helpers/persistAppointmentTasks';
import { TaskProcessor } from './task-processor';

export const TaskProcessorProviderWrapper: FCC = ({ children }) => {
  const apiClient = useApiClient();
  const apolloClient = useApolloClient();
  const logger = useNamedLogger('TaskProcessor');
  const tenantId = useAssignedTenantIdFromParams();
  const userId = useUserIdFromSession();

  const taskProcessor = useMemo(() => {
    const taskHandlers = createTaskHandlers({
      apolloClient: apolloClient as ApolloClient<NormalizedCacheObject>,
      apiClient,
      logger,
    });

    return new TaskProcessor({
      userId,
      tenantId,
      dependencies: {
        getPersistedTasks,
        persistAppointmentTasks,
        logger,
        taskHandlers,
      },
    });
  }, [userId, tenantId, apolloClient, apiClient, logger]);

  return (
    <TaskProcessorProvider taskProcessor={taskProcessor}>
      {children}
    </TaskProcessorProvider>
  );
};
